import React, { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLazyQuery } from '@apollo/client';

import WDT_OVERALL_ERROR_QUERY from 'graph/reports/wdt-overall-error-report-query';
import useReportQueryParams from '../../../hooks/use-report-query-params';
import PieChart from 'components/@common/Charts/PieChart';
import ReportCard from '../../common/ReportCard';
import { WdtErrorData } from 'types/schema-generated-types';
import { keyBy } from 'lodash';
import { getQueryVariables } from '../../../utils/report-param-utils';
import { CHARACTER_ERROR_TYPES, CHARACTER_ERROR_COLORS } from '../../../utils/report-wdt-utils';
import { PrintViewContext } from 'components/ReportsModule/providers/PrintViewProvider';

const ErrorAnalysisStrokeTypeInfluenceChartView: React.FC = () => {
  const [{ dateRange, entityType, entityId }] = useReportQueryParams();
  const [fetchReport, { data, loading }] = useLazyQuery(WDT_OVERALL_ERROR_QUERY);
  const { cardChartWidth } = useContext(PrintViewContext);
  const { t } = useTranslation('Reports');

  const reportData: WdtErrorData[] = data?.wdtOverallErrorsReport?.errors ?? [];

  const errorsByType = keyBy(reportData, 'type');

  useEffect(() => {
    fetchReport({
      variables: getQueryVariables({ entityId, entityType, dateRange })
    });
  }, [fetchReport, entityId, entityType, dateRange]);

  return (
    <ReportCard title={t(`Stroke Type Influence %`)} loading={loading} reportData={reportData}>
      <PieChart
        height={300}
        width={cardChartWidth}
        series={CHARACTER_ERROR_TYPES.map(type => errorsByType[type]?.count ?? 0)}
        options={{
          colors: CHARACTER_ERROR_COLORS,
          labels: CHARACTER_ERROR_TYPES.map(type => t(type, { ns: 'CharacterErrorType' })),
          dataLabels: { enabled: false },
          legend: {
            show: true,
            position: 'bottom',
            horizontalAlign: 'left',
            showForSingleSeries: true,
            showForNullSeries: true,
            showForZeroSeries: true
            // style: {
            //   colors: '#373D3F',
            //   fontSize: '10px',
            //   fontFamily: 'futura-pt'
            // }
          }
        }}
      />
    </ReportCard>
  );
};

export default ErrorAnalysisStrokeTypeInfluenceChartView;
